var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryInvestment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/investment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/investment"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 9.000000)",
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.07853297,14.3145 L9.84446703,14.3145 C10.9867747,14.3145 11.9115,15.2505 11.9115,16.4067353 L11.9115,26.0145 L2.0115,26.0145 L2.0115,16.4067353 C2.0115,15.2505 2.93622527,14.3145 4.07853297,14.3145 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.678533,8.0145 L22.444467,8.0145 C23.5867747,8.0145 24.5115,8.93066766 24.5115,10.0624042 L24.5115,26.0145 L14.6115,26.0145 L14.6115,10.0624042 C14.6115,8.93066766 15.5362253,8.0145 16.678533,8.0145 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.178533,0.8145 L35.944467,0.8145 C37.0867747,0.8145 38.0115,1.75500494 38.0115,2.91680516 L38.0115,26.0145 L28.1115,26.0145 L28.1115,2.91680516 C28.1115,1.75500494 29.0362253,0.8145 30.178533,0.8145 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2115,30.0645 C0.2115,29.3895 0.754709877,28.8225 1.46088272,28.8225 L38.5621173,28.8225 C39.2411296,28.8225 39.8115,29.3625 39.8115,30.0645 C39.8115,30.7665 39.2682901,31.3065 38.5621173,31.3065 L1.46088272,31.3065 C0.754709877,31.3065 0.2115,30.7395 0.2115,30.0645 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryInvestment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-investment.b8abeeb9d7188f9dc859400ca6a2d2b5.svg";